var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvcMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_564_4436)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05991 5.86021C10.3403 2.5798 15.6589 2.5798 18.9393 5.86021C22.2197 9.14061 22.2197 14.4592 18.9393 17.7395L12.9996 23.6793L7.05991 17.7395C3.77951 14.4592 3.77951 9.14061 7.05991 5.86021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5857 6.21375L18.5857 6.21376C21.6709 9.2989 21.6709 14.3009 18.5857 17.386L18.5857 17.386L12.9996 22.9722L7.41347 17.386L7.41346 17.386C4.32833 14.3009 4.32832 9.2989 7.41347 6.21376C10.4986 3.12861 15.5006 3.12862 18.5857 6.21375Z",
    stroke: "#2D9764"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_564_4436)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6667 13.55L14.3332 13.1625L15.0001 12.775L15.6666 12.3875V13.9375L15.0001 14.325L14.3332 14.7125L13.6667 15.1L13.0002 15.4875L12.3336 15.875H12.3333L11.6668 15.4875L11.0002 15.1L10.3334 14.7125L9.66685 14.325H9.66653L9 13.9375V10.0625L9.66653 9.675H9.66685L10.3334 9.2875L10.9999 8.9H11.0002L11.6668 8.5125L12.3333 8.125H12.3336L13.0002 8.5125L13.6667 8.9L13.0002 9.2875L12.3336 9.675L11.6668 10.0625L11.0002 10.45L10.3334 10.8375V12.3875L11.0002 12L11.6668 11.6125L12.3336 11.225L13.0002 10.8375L13.6667 10.45L14.3332 10.8375V11.6125L13.6667 12L13.0002 12.3875L12.3336 12.775L11.6668 13.1625L11.0002 13.55L11.6668 13.9375L12.3336 14.325L13.0002 13.9375L13.6667 13.55ZM16.286 8.87255L16.9529 9.26005L17 9.2875V11.6125L16.6821 11.7975L15.6666 12.3875V10.0625L15.5665 10.0044L15.0001 9.675L14.3862 9.31818L14.3332 9.2875L14.2332 9.22938L13.6667 8.9L14.3878 8.48085L15.0001 8.125L15.6195 8.48505L15.6666 8.5125L16.286 8.87255Z",
    fill: "url(#paint0_linear_564_4436)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_564_4436",
    x: 0.599609,
    y: 0.399902,
    width: 24.7998,
    height: 28.2793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_564_4436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_564_4436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_564_4436",
    x1: 9.00739,
    y1: 13.9052,
    x2: 17.0206,
    y2: 9.35001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D9764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29913"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_4436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvcMarker);
export default __webpack_public_path__ + "static/media/evc-marker.5a721be478dcd303778d27106930fe9f.svg";
export { ForwardRef as ReactComponent };